import { MovementRoute } from "./movementRoute";

export interface TransportationExpense {
  id: number;
  at: string;
  account: string;
  totalDistanceKm: number;
  totalFare: number;
  totalTime: number;
  arrivalId: number;
  arrivalCode: string;
  arrivalName: string;
  arrivalTime: Date;
  departureId: number;
  departureCode: string;
  departureName: string;
  departureTime: Date;
  movementRoutes: MovementRoute[];
  modifiedBy: "user" | "system";
}

export interface FetchResult {
  id: number;
  movementRoutes: MovementRoute[];
}

export const filterZeroFareBySystem = (
  result: FetchResult,
  transportationExpenses: TransportationExpense[]
): void => {
  const len = transportationExpenses.length;

  for (let i = len - 1; i >= 0; i -= 1) {
    const transportationExpense = transportationExpenses[i];
    // eslint-disable-next-line no-continue
    if (transportationExpense.id !== result.id) continue;

    if (transportationExpense.modifiedBy === "user") {
      // ユーザーが入力したものはそのまま使う
      transportationExpense.movementRoutes = result.movementRoutes;
      // eslint-disable-next-line no-continue
      continue;
    }

    const movementRoutes = result.movementRoutes.filter(
      (m) => m.useCommuterPass || (!!m.fare && m.fare !== 0)
    );

    if (movementRoutes.length > 0) {
      transportationExpense.movementRoutes = movementRoutes;
    } else {
      // 表示するものがない時はtransportationExpensesごと表示しない
      transportationExpenses.splice(i, 1);
    }
  }
};
